import { Home, Calendar, BarChart3, ShoppingCart, Settings } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const BottomNav = ({ beforeNavigate }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  // Centralized outbound-navigation hook. When a host screen (e.g. Log Food with an unlogged cart)
  // passes `beforeNavigate` and it returns false, the tab switch is blocked so the host can prompt.
  function go(path) {
    if (typeof beforeNavigate === 'function' && beforeNavigate(path) === false) return;
    navigate(path);
  }

  function isActive(path) {
    if (path === '/home') return currentPath === '/home';
    if (path === '/plan') return currentPath === '/plan' || currentPath.startsWith('/plan/');
    if (path === '/progress') return currentPath === '/progress';
    if (path === '/grocery') return currentPath === '/grocery';
    if (path === '/settings') return currentPath === '/settings';
    return false;
  }

  function getButtonClass(path) {
    const base = 'flex flex-col items-center justify-center gap-1 px-3 py-2 transition-colors';
    if (isActive(path)) {
      return base + ' text-accent';
    }
    return base + ' text-muted-foreground hover:text-foreground';
  }

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-background/80 backdrop-blur-xl border-t border-border/40 pb-safe z-50"
      data-testid="bottom-navigation"
    >
      <div className="h-16 flex items-center justify-around">
      <button
        data-testid="nav-home"
        onClick={function() { go('/home'); }}
        className={getButtonClass('/home')}
      >
        <Home size={20} strokeWidth={1.5} />
        <span className="text-xs">Home</span>
      </button>

      <button
        data-testid="nav-plan"
        onClick={function() { go('/plan'); }}
        className={getButtonClass('/plan')}
      >
        <Calendar size={20} strokeWidth={1.5} />
        <span className="text-xs">Plan</span>
      </button>

      <button
        data-testid="nav-progress"
        onClick={function() { go('/progress'); }}
        className={getButtonClass('/progress')}
      >
        <BarChart3 size={20} strokeWidth={1.5} />
        <span className="text-xs">Progress</span>
      </button>

      <button
        data-testid="nav-grocery"
        onClick={function() { go('/grocery'); }}
        className={getButtonClass('/grocery')}
      >
        <ShoppingCart size={20} strokeWidth={1.5} />
        <span className="text-xs">Grocery</span>
      </button>

      <button
        data-testid="nav-settings"
        onClick={function() { go('/settings'); }}
        className={getButtonClass('/settings')}
      >
        <Settings size={20} strokeWidth={1.5} />
        <span className="text-xs">Settings</span>
      </button>
      </div>
    </nav>
  );
};

export default BottomNav;
